<!-- DeleteCouponForm.vue -->
<script setup>
import { computed } from "vue";
import { useCouponStore } from "@/stores/useCouponStore";
import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";

const props = defineProps({
  coupon: {
    type: Object,
    required: true,
  },
});

// ✅ Mantém o mesmo padrão de DeleteActivityForm.vue / DeleteTextForm.vue
const emit = defineEmits(["close", "refresh", "notify"]);
const store = useCouponStore();

// ✅ Código do coupon vindo da store, com fallback na prop
const couponCode = computed(() => {
  return (
    store.selectedCoupon?.code ||
    store.selectedCoupon?.Code ||
    props.coupon?.code ||
    props.coupon?.Code ||
    ""
  );
});

// ✅ ID do coupon vindo da prop, com tolerância a PascalCase
const couponId = computed(() => {
  return props.coupon?.couponId || props.coupon?.CouponId || null;
});

// ✅ Mensagem da pergunta de confirmação com código do coupon
const messageTitle = computed(() => {
  const code = couponCode.value?.trim();
  if (!code) return "Tem certeza que deseja apagar este coupon?";
  return `Tem certeza que deseja apagar o coupon "${code}"?`;
});

function buildDeleteCouponError(error) {
  const raw =
    error?.response?.data?.message ||
    error?.message ||
    "Ocorreu um erro ao excluir o coupon.";

  return raw;
}

async function onConfirmDelete() {
  try {
    if (!couponId.value) {
      throw new Error("ID do coupon não encontrado para exclusão.");
    }

    await store.deleteCouponById(couponId.value);

    // ✅ Toast genérico, sem código do coupon
    emit("notify", {
      type: "success",
      message: "Coupon apagado com sucesso.",
    });

    // ✅ Mantém comportamento original
    emit("refresh");
    emit("close");
  } catch (error) {
    const msg = buildDeleteCouponError(error);

    emit("notify", {
      type: "error",
      message: msg,
    });

    // ✅ Mantém padrão: throw para o modal parar o loading
    throw new Error(msg);
  }
}
</script>

<template>
  <DeleteConfirmModal
    :show="true"
    title="Apagar Coupon"
    :messageTitle="messageTitle"
    messageSubtitle="Ao apagá-lo, o coupon deixará de estar disponível para uso. Esta ação não pode ser desfeita."
    confirmText="Sim, apagar"
    cancelText="Cancelar"
    loadingText="Apagando..."
    :onConfirm="onConfirmDelete"
    @close="emit('close')"
  />
</template>
